<template>
    <div>
        <BOM_Import :importUrl='url' />
    </div>
</template>

<script>
import BOM_Import from "./ImportBOMsByLevel.vue";


export default {
    data() {
        return {
            url: '/pmdm/import/importCommonBOMByLevel'
        }
    },
    components: {
        BOM_Import
    }
}
</script>